import { createRoutesFromElements, Navigate, Route, useLocation } from "react-router-dom";
import { GlobalFallback } from "./components/error_handling/GlobalFallback";
import { Layout } from "./layout/Layout";
import { AccountManagement } from "./pages/AccountManagement";
import { Appointments } from "./pages/Appointments";
import { EvcImportPage } from "./pages/EvcImportPage";
import { HealthRecord } from "./pages/HealthRecord";
import Homepage from "./pages/HealthRecords";
import { NotFound } from "./pages/NotFound";
import { QuickShare } from "./pages/QuickShare";
import { TriggerTestError } from "./pages/TriggerTestError";
import { EditHealthRecord } from "./pages/health_record/EditHealthRecord";
import { EditVaccinationAct } from "./pages/health_record/EditVaccination";
import { HealthRecordAppointments } from "./pages/health_record/HealthRecordAppointments";
import { NewHealthRecord } from "./pages/health_record/NewHealthRecord";
import { RedeemSharingToken } from "./pages/health_record/RedeemSharingToken";
import Share from "./pages/health_record/Share";
import { Shares } from "./pages/health_record/Shares";
import { VaccinationActs } from "./pages/health_record/VaccinationActs";
import { TravelDiagnosticSelector } from "./pages/health_record/diagnostic/TravelDiagnosticSelector";
import { Documents } from "./pages/health_record/documents/Documents";
import { Profile } from "./pages/health_record/profile/Profile";
import { Travel } from "./pages/health_record/travel/Travel";

function RootRedirect() {
  const location = useLocation();
  const evcToken = new URLSearchParams(location.search).get("evc");

  if (evcToken) {
    const search = new URLSearchParams({ evc: evcToken });
    return <Navigate to={`/evc-import?${search.toString()}`} replace={true} />;
  }

  return <Navigate to="/health-records" replace={true} />;
}

export const routes = ({ calendarUrl }: { calendarUrl: string }) => {
  return createRoutesFromElements(
    <Route path="/" element={<Layout />} errorElement={<GlobalFallback />}>
      <Route path="/" element={<RootRedirect />} />
      <Route path="/quick-share/:id" element={<QuickShare />} />
      <Route path="/health-records" element={<Homepage />} />
      <Route path="/health-records/redeem-sharing-token" element={<RedeemSharingToken />} />
      <Route path="/health-records/new" element={<NewHealthRecord />} />
      <Route path="/health-records/:id" element={<HealthRecord />}>
        <Route path="" element={<VaccinationActs />} />
        <Route path="vaccination/:vaccinationActId" element={<EditVaccinationAct />} />
        <Route path="shares" element={<Shares />} />
        <Route path="share" element={<Share />} />
        <Route path="edit" element={<EditHealthRecord />} />
        <Route path="profile" element={<Profile />} />
        <Route path="travel" element={<Travel />} />
        <Route path="diagnosis" element={<TravelDiagnosticSelector />} />
        <Route path="documents" element={<Documents />} />
        <Route path="appointments" element={<HealthRecordAppointments calendarUrl={calendarUrl} />} />
      </Route>
      <Route path="/appointments" element={<Appointments calendarUrl={calendarUrl} />} />
      <Route path="/evc-import" element={<EvcImportPage />} />
      <Route path="account" element={<AccountManagement />} />
      <Route path="/test-error" element={<TriggerTestError />} />
      <Route path="/not_found" element={<NotFound />} />
      <Route path="*" element={<Navigate to="/not_found" replace={true} />} />
    </Route>,
  );
};
